import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FormControl } from '../../types/form-control.type';

@Pipe({ name: 'controlSourceTypePipe'})
export class ControlSourceTypePipe implements PipeTransform {
    transform(items: FormControl[], sourceType: string): any {
        if (!items) return;
        return items;
    }
}

@Pipe({ name: 'safeHtml' })
export class ControlSafeHtmlPipe {
    constructor(private sanitizer: DomSanitizer) { }

    transform(html) {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/shared/control-source-type-pipe.ts